module.exports = __webpack_public_path__ + "img/tu3.47cb38fa.png";